export function wrapContent(input, dataSource) {
    let result = "";

    try {
        if (input.includes("${")) {
            result = replaceKeys(input, dataSource);
        } else {
            result = input;
        }
    } catch (e) {
        result = input;
    }

    return result;
}

const replaceKeys = (input, dataSource, index) => {
    let result = input;

    const keyList = Object.keys(dataSource);

    try {
        for (let i = 0; i < keyList.length; i++) {
            const key = keyList[i];

            if (typeof dataSource[key] == typeof {}) {
                if (dataSource[key].length > 0) {
                    const index = retrieveKeyIndex(
                        result,
                        dataSource[key],
                        key
                    );
                    if (index >= 0) {
                        try {
                            if (typeof dataSource[key][index] == typeof {}) {
                                result = replaceKeys(
                                    result,
                                    dataSource[key][index],
                                    index
                                );
                            } else {
                                result = result.replace(
                                    "${" + key + "." + index + "}",
                                    dataSource[key][index]
                                );
                            }
                        } catch (e) {}
                    }
                } else {
                    result = replaceKeys(result, dataSource[key]);
                }
            } else {
                result = result.replace("${" + key + "}", dataSource[key]);
                if (index != null && index >= 0) {
                    result = result.replace(
                        "${" + key + "." + index + "}",
                        dataSource[key]
                    );
                }
            }
        }
    } catch (e) {
        console.log(e);
    }

    return result;
};

const retrieveKeyIndex = (input, dataList, originKey) => {
    // Required html ${<name>.<index>}

    for (let i = 0; i < dataList.length; i++) {
        let searchValue = "";

        if (typeof dataList[i] == typeof {}) {
            const keyList = Object.keys(dataList[i]);

            for (let a = 0; a <= keyList.length; a++) {
                const key = keyList[a];
                searchValue = "${" + key;
                if (input.includes(searchValue)) {
                    const startIndex = input.indexOf(searchValue);

                    try {
                        const charAt = input.charAt(
                            startIndex + searchValue.length + 1
                        );

                        if (charAt >= "0" && charAt <= "9") {
                            return charAt;
                        }
                    } catch (e) {
                        return 0;
                    }
                }
            }
        } else {
            searchValue = "${" + originKey;
            if (input.includes(searchValue)) {
                const startIndex = input.indexOf(searchValue);

                try {
                    const charAt = input.charAt(
                        startIndex + searchValue.length + 1
                    );

                    if (charAt >= "0" && charAt <= "9") {
                        return charAt;
                    }
                } catch (e) {
                    return 0;
                }
            }
        }
    }
    return -1;
};
